var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCaseStudy2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "reshot-icon-idea-FH48GZT7RY 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_12_",
    d: "M22.125 41.7319V41.9869C22.125 42.9713 22.9219 43.7682 23.9062 43.7682C24.8906 43.7682 25.6875 42.9713 25.6875 41.9869V41.7319H28.2281C28.7363 41.7319 29.1975 41.4338 29.4075 40.9707L29.4844 40.8001C29.7 40.3219 29.8125 39.8044 29.8125 39.2813V36.1463C29.8125 35.7094 29.46 35.3569 29.0231 35.3569H19.1644C18.7275 35.3569 18.375 35.7094 18.375 36.1463V39.3094C18.375 39.8419 18.4912 40.3688 18.7144 40.8526L18.9844 41.4376C19.0687 41.6213 19.2544 41.7376 19.4569 41.7338L20.1394 41.7207",
    stroke: "#EE4540",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_10_",
    d: "M29.4375 33.6695V31.787C29.4375 30.4933 29.9569 29.2445 30.9 28.3595C32.8819 26.4977 34.1231 23.8558 34.1231 20.9214C34.1231 13.8714 26.9831 8.49016 19.5394 11.6139C17.3419 12.5364 15.5719 14.282 14.6344 16.472C12.66 21.0827 13.9575 25.5695 16.8937 28.3408C17.8425 29.2352 18.3769 30.4839 18.3769 31.787V33.6695",
    stroke: "#EE4540",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_80_",
    d: "M20.25 37.2319H25.3125",
    stroke: "#EE4540",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_11_",
    d: "M22.875 39.4819H27.9375",
    stroke: "#EE4540",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M24 4.23193V8.35693",
    stroke: "#EE4540",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M32.2612 6.49683L30.2081 10.05",
    stroke: "#EE4540",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M38.3737 12.5513L34.8206 14.6006",
    stroke: "#EE4540",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M40.6875 20.9195L36.5625 20.9158",
    stroke: "#EE4540",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M38.4506 29.1712L34.8994 27.1162",
    stroke: "#EE4540",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M9.6675 29.2839L13.2244 27.2383",
    stroke: "#EE4540",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M7.3125 21.1069L11.4375 21.1144",
    stroke: "#EE4540",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M9.61312 12.6638L13.1625 14.7226",
    stroke: "#EE4540",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M15.6787 6.5625L17.7225 10.1194",
    stroke: "#EE4540",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M22.875 33.482V31.757C22.875 29.7395 22.1494 27.7876 20.8312 26.2614C20.6269 26.0251 20.5144 25.7233 20.5144 25.4101C20.5144 24.692 21.0975 24.1089 21.8156 24.1089H24.75",
    stroke: "#EE4540",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaseStudy2);
export default __webpack_public_path__ + "static/media/caseStudy2.13ef17647644efc4d29cfee24a36c02c.svg";
export { ForwardRef as ReactComponent };